import React, { useRef, useEffect } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cIcon,
  I2cTooltip,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import applePay from "../../../assets/images/apple_pay.svg";
import googlePay from "../../../assets/images/google_pay.svg";
import samsungPay from "../../../assets/images/samsung_pay.svg";
import fitbit from "../../../assets/images/fitbit_pay.svg";
import garminPay from "../../../assets/images/garmin_pay.svg";
import cardPlaceholder from "../../../assets/images/card-placeholder.svg";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
export const features = [
  {
    label: "Apple Pay",
    value: "apple-pay",
    icon: applePay,
  },
  {
    label: "Google Pay",
    value: "google-pay",
    icon: googlePay,
  },
  {
    label: "Samsung Pay",
    value: "samsung-pay",
    icon: samsungPay,
  },
  {
    label: "Fitbit Pay",
    value: "fitbit-pay",
    icon: fitbit,
  },
  {
    label: "Garmin Pay",
    value: "garmin-pay",
    icon: garminPay,
  },
  {
    label: "Others",
    value: "others",
    icon: cardPlaceholder,
  },
];
export const otpDeliveryMethods = [
  { label: "E-mail", value: "email" },
  { label: "SMS", value: "sms" },
  { label: "SMPP Integration", value: "smpp-integration" },
  { label: "Push API", value: "push-api" },
];
export const yellowPathOtp = [
  { label: "OTP via E-mail", value: "via-email" },
  { label: "OTP via SMS", value: "via-sms" },
  { label: "Speak to Live Agent", value: "live-agent" },
];
export const liveAgent = [
  { label: "i2c Inc.", value: "i2c" },
  { label: "Client/Bank", value: "client-bank" },
  { label: "Other, please specify", value: "other" },
];
export const emailAgent = [
  { label: "i2c Inc.", value: "i2c" },
  { label: "Client/Bank", value: "client-bank" },
  { label: "Other, please specify", value: "other" },
];
const DigitalWallet = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    of_dw_mobile_wallets: Yup.array()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    of_dw_mobile_wallet_other: Yup.string().when("of_dw_mobile_wallets", {
      is: (wallets) => wallets.includes("others"),
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_dw_card_holders: Yup.array().optional(),
    of_dw_live_agent: Yup.string().when("of_dw_card_holders", {
      is: (cardholders) => cardholders.includes("live-agent"),
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_dw_live_agent_other: Yup.string().when("of_dw_live_agent", {
      is: (live_agent) => live_agent === "other",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_dw_email_authentication: Yup.string().when("of_dw_card_holders", {
      is: (cardholders) => cardholders.includes("via-email"),
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_dw_email_authentication_other: Yup.string().when(
      "of_dw_email_authentication",
      {
        is: (authentication_method) => authentication_method === "other",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),

    of_dw_provisioning_process: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    of_dw_i2c_mobile_app_host: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    of_dw_service_enable_via: Yup.string().when("of_dw_i2c_mobile_app_host", {
      is: (of_dw_i2c_mobile_app_host) => of_dw_i2c_mobile_app_host === "no",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      of_dw_mobile_wallets: [],
      of_dw_mobile_wallet_other: "",
      of_dw_card_holders: [],
      of_dw_live_agent: "",
      of_dw_live_agent_other: "",
      of_dw_email_authentication: "",
      of_dw_email_authentication_other: "",
      of_dw_otp_delivery: [],
      of_dw_provisioning_process: "",
      of_dw_i2c_mobile_app_host: "",
      of_dw_service_enable_via: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "of_dw_mobile_wallets",
    "of_dw_mobile_wallet_other",
    "of_dw_card_holders",
    "of_dw_live_agent",
    "of_dw_live_agent_other",
    "of_dw_email_authentication",
    "of_dw_email_authentication_other",
    "of_dw_otp_delivery",
    "of_dw_provisioning_process",
    "of_dw_i2c_mobile_app_host",
    "of_dw_service_enable_via",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[6]["6_4"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      6: {
        ...addFormData["6"],
        "6_4": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("6_4", true);
    else setFormValidStates("6_4", false);
  }, [Object.keys(errors).length]);
  const checkboxRef = useRef(null);
  const inAppProvision = ["Yes", "No"];
  const enableServices = ["SDK", "API"];
  const handleCheckboxGroupChange = (event) => {
    let selectedValues;
    if (!event.length) selectedValues = event.target.value;
    else selectedValues = event;
    let updatedValues = [...(methods.getValues("of_dw_mobile_wallets") ?? [])];
    if (updatedValues.includes(selectedValues)) {
      // If the card is already selected, remove it
      updatedValues = updatedValues.filter((card) => card !== selectedValues);
    } else {
      // If the card is not selected, add it
      updatedValues.push(selectedValues);
    }

    if (updatedValues.includes("apple-pay")) {
      const vals = yellowPathOtp.map((obj) => obj.value);
      methods.setValue("of_dw_card_holders", vals);
    }
    if (!updatedValues.includes("others")) {
      methods.setValue("of_dw_mobile_wallet_other", "");
    }
    methods.setValue("of_dw_mobile_wallets", updatedValues);
    methods.trigger();
    handleValueChanges();
  };

  const handleYellowPathChange = (event) => {
    let selectedValues;
    if (!event.length) selectedValues = event.target.value;
    else selectedValues = event;
    let updatedValues = [...(methods.getValues("of_dw_card_holders") ?? [])];
    if (updatedValues.includes(selectedValues)) {
      // If the card is already selected, remove it
      updatedValues = updatedValues.filter((card) => card !== selectedValues);
    } else {
      // If the card is not selected, add it
      updatedValues.push(selectedValues);
    }
    if (!updatedValues.includes("live-agent")) {
      methods.setValue("of_dw_live_agent", "");
      methods.setValue("of_dw_live_agent_other", "");
    }
    if (!updatedValues.includes("via-email")) {
      methods.setValue("of_dw_email_authentication", "");
      methods.setValue("of_dw_email_authentication_other", "");
    }
    methods.setValue("of_dw_card_holders", updatedValues);
    methods.trigger();
    handleValueChanges();
  };
  const handleOTPDeliveryMethodsChange = (event) => {
    let selectedValues;
    if (!event?.length) selectedValues = event.target.value;
    else selectedValues = event;
    let updatedValues = [...(methods.getValues("of_dw_otp_delivery") ?? [])];
    if (updatedValues.includes(selectedValues)) {
      // If the card is already selected, remove it
      updatedValues = updatedValues.filter((card) => card !== selectedValues);
    } else {
      // If the card is not selected, add it
      updatedValues.push(selectedValues);
    }
    methods.setValue("of_dw_otp_delivery", updatedValues);
    handleValueChanges();
    methods.trigger();
  };
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div className="section-space">
          <span slot="label" className="organize-tooltip mb-16">
            <div className="sub-heading">Mobile Wallets</div>
            <I2cTooltip
              content="As a pre-requisite to initiate mobile wallet setup, the sponsor bank must have a have a contract with the mobile wallet service provider and the BIN should already be live on the card network."
              placement="right-start"
            >
              <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
            </I2cTooltip>
          </span>
          <I2cCheckboxGroup className="centeredCheckbox" ref={checkboxRef}>
            <div i2c-grid="grid gap-sm">
              {features.map((card, index) => (
                <I2cListItem
                  key={index}
                  i2c-grid="4@md"
                  style={{ display: "flex", alignItems: "center" }}
                  variant="receipt"
                  label={card.label}
                  sublabel=""
                  value=""
                  type="checkbox"
                  checked={
                    methods
                      .watch("of_dw_mobile_wallets")
                      ?.includes(card.value) ?? false
                  }
                  onI2cCheckboxClicked={(e) => {
                    handleCheckboxGroupChange(card.value);
                    methods.trigger();
                    handleValueChanges();
                  }}
                  size="sm"
                >
                  <I2cIcon
                    slot="prefix"
                    src={card.icon}
                    style={{ fontSize: "var(--i2c-spacing-10-5)" }}
                    label="icon"
                  ></I2cIcon>
                  <I2cCheckbox
                    name="ofdw_features"
                    slot="checkbox"
                    value={card.value}
                    label=""
                    filled
                    checked={
                      methods
                        .watch("of_dw_mobile_wallets")
                        ?.includes(card.value) ?? false
                    }
                
                    className="custom-checkbox-auto-margin"
                  ></I2cCheckbox>
                </I2cListItem>
              ))}
            </div>
          </I2cCheckboxGroup>
          <div i2c-grid="grid">
            {methods.watch("of_dw_mobile_wallets").includes("others") && (
              <div i2c-grid="6@md" className="mt-16">
                <div className="single-field-wrapper">
                  <Controller
                    name="of_dw_mobile_wallet_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"of_dw_mobile_wallet_other"}
                        className="single-input-field"
                        placeholder="Other Details"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          methods.trigger();
                          handleValueChanges();
                        }}
                        required
                        size="large"
                        label="Enter Details"
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.of_dw_mobile_wallet_other &&
                      methods.formState.touchedFields.of_dw_mobile_wallet_other
                        ? true
                        : false
                    }
                    message={
                      errors.of_dw_mobile_wallet_other?.message ??
                      "Invalid input"
                    }
                  /> */}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="section-space">
          <div i2c-grid="grid gap-md">
            <div i2c-grid="12">
              <div className="sub-heading mb-4">
                Authentication for Yellow Path cardholders
              </div>
              <div className="custom-label-light mb-16">
                For Yellow Path (cardholders failing enrollment), please confirm
                what alternate methods for Cardholder Authentication will be
                used:
              </div>
              <I2cCheckboxGroup ref={checkboxRef}>
                <div i2c-grid="grid gap-sm">
                  {yellowPathOtp.map((yellowPathOtp, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="4@md"
                      variant="receipt"
                      label={yellowPathOtp.label}
                      sublabel=""
                      value=""
                      disabled={methods
                        .watch("of_dw_mobile_wallets")
                        .includes("apple-pay")}
                      checked={
                        methods
                          .watch("of_dw_card_holders")
                          ?.includes(yellowPathOtp.value) ?? false
                      }
                      onI2cCheckboxClicked={
                        methods
                          .watch("of_dw_mobile_wallets")
                          .includes("apple-pay")
                          ? () => null
                          : (e) => handleYellowPathChange(yellowPathOtp.value)
                      }
                      className={
                        methods
                          .watch("of_dw_mobile_wallets")
                          .includes("apple-pay")
                          ? "disable-events"
                          : ""
                      }
                      type="checkbox"
                    >
                      <I2cCheckbox
                        slot="prefix"
                        name="ofdw_otpDelivery"
                        value={yellowPathOtp.value}
                        label=""
                        filled
                        checked={
                          methods
                            .watch("of_dw_card_holders")
                            ?.includes(yellowPathOtp.value) ?? false
                        }
                        className="customCheckbox"
                      ></I2cCheckbox>
                    </I2cListItem>
                  ))}
                </div>
              </I2cCheckboxGroup>
            </div>
            {methods.watch("of_dw_card_holders").includes("live-agent") && (
              <div i2c-grid="12">
                <I2cRadioGroup
                  label="If opting for “Live Agent”, please confirm who will provide the
                  contact center service for Live Agent support for cardholders:"
                  onI2cChange={(e) => {
                    methods.setValue("of_dw_live_agent", e.target.value);
                    if (e.target.value !== "other") {
                      methods.setValue("of_dw_live_agent_other", "");
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  <div i2c-grid="grid gap-sm">
                    {liveAgent.map((radio, index) => (
                      <I2cListItem
                        key={index}
                        i2c-grid="4@md"
                        variant="receipt"
                        label={radio.label}
                        sublabel=" "
                        value=""
                        checked={
                          methods.watch("of_dw_live_agent") === radio.value ??
                          false
                        }
                        type="checkbox"
                      >
                        <I2cRadio
                          filled
                          checked={
                            methods.watch("of_dw_live_agent") === radio.value ??
                            false
                          }
                          slot="prefix"
                          name="ofdw_liveAgent"
                          value={radio.value}
                        ></I2cRadio>
                      </I2cListItem>
                    ))}
                  </div>
                </I2cRadioGroup>
                {methods.watch("of_dw_live_agent") === "other" && (
                  <div i2c-grid="grid 6@md" className="mt-16">
                    <div className="single-field-wrapper">
                      <Controller
                        name="of_dw_live_agent_other"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            name={"of_dw_live_agent_other"}
                            className="single-input-field"
                            placeholder="Please Specify"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              methods.trigger();
                              handleValueChanges();
                            }}
                            required={
                              errors.of_dw_live_agent_other ? true : false
                            }
                            size="large"
                            label="Enter Details"
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.of_dw_live_agent_other &&
                          methods.formState.touchedFields.of_dw_live_agent_other
                            ? true
                            : false
                        }
                        message={
                          errors.of_dw_live_agent_other?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                )}
              </div>
            )}

            {methods.watch("of_dw_card_holders").includes("via-email") && (
              <div i2c-grid="12">
                <I2cRadioGroup
                  label="If opting for “E-mail”, please confirm who will manage:"
                  onI2cChange={(e) => {
                    methods.setValue(
                      "of_dw_email_authentication",
                      e.target.value,
                    );
                    if (e.target.value !== "other") {
                      methods.setValue("of_dw_email_authentication_other", "");
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  <div i2c-grid="grid gap-sm">
                    {emailAgent.map((radio, index) => (
                      <I2cListItem
                        key={index}
                        i2c-grid="4@md"
                        variant="receipt"
                        label={radio.label}
                        sublabel=" "
                        value=" "
                        type="checkbox"
                        checked={
                          methods.watch("of_dw_email_authentication") ===
                            radio.value ?? false
                        }
                      >
                        <I2cRadio
                          slot="prefix"
                          filled
                          checked={
                            methods.watch("of_dw_email_authentication") ===
                              radio.value ?? false
                          }
                          name="ofdw_emailAgent"
                          value={radio.value}
                        ></I2cRadio>
                      </I2cListItem>
                    ))}
                  </div>
                </I2cRadioGroup>
                {methods.watch("of_dw_email_authentication") === "other" && (
                  <div i2c-grid="grid 12">
                    <div className="single-field-wrapper halfWidth mt-16">
                      <Controller
                        name="of_dw_email_authentication_other"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            name={"of_dw_email_authentication_other"}
                            className="single-input-field"
                            placeholder="Please Specify"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              methods.trigger();
                              handleValueChanges();
                            }}
                            required
                            size="large"
                            label="Enter Details"
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.of_dw_email_authentication_other &&
                          methods.formState.touchedFields
                            .of_dw_email_authentication_other
                            ? true
                            : false
                        }
                        message={
                          errors.of_dw_email_authentication_other?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="section-space">
          <div i2c-grid="grid gap-md">
            <div i2c-grid="12">
              <div className="sub-heading">OTP Delivery</div>
              <I2cCheckboxGroup
                label="Please confirm how would you like the OTP to be delivered to
              cardholders"
              >
                <div i2c-grid="grid gap-sm">
                  {otpDeliveryMethods.map((otpDeliveryMethod, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="4@md"
                      variant="receipt"
                      label={otpDeliveryMethod.label}
                      sublabel=""
                      value=""
                      checked={
                        methods
                          .watch("of_dw_otp_delivery")
                          ?.includes(otpDeliveryMethod.value) ?? false
                      }
                      onI2cCheckboxClicked={(e) =>
                        handleOTPDeliveryMethodsChange(otpDeliveryMethod.value)
                      }
                      type="checkbox"
                    >
                      <I2cCheckbox
                        slot="prefix"
                        name="ofdw_otpDelivery"
                        value={otpDeliveryMethod.value}
                        checked={
                          methods
                            .watch("of_dw_otp_delivery")
                            ?.includes(otpDeliveryMethod.value) ?? false
                        }
                        label=""
                        filled
                        className="customCheckbox"
                      ></I2cCheckbox>
                    </I2cListItem>
                  ))}
                </div>
              </I2cCheckboxGroup>
            </div>
          </div>
        </div>
        <div i2c-grid="grid gap-md">
          <div i2c-grid="12">
            <div className="sub-heading">
              Digital Wallet Provisioning Process
            </div>
            <I2cRadioGroup
              label="Would you like to enable In-App Provisioning (Push Provisioning)
              with Digital Wallets?"
              onI2cChange={(e) => {
                methods.setValue("of_dw_provisioning_process", e.target.value);
                methods.trigger();
                handleValueChanges();
              }}
            >
              {inAppProvision.map((radio, index) => (
                <I2cRadioButton
                  key={index}
                  checked={
                    methods.watch("of_dw_provisioning_process") ===
                    radio.toLowerCase()
                  }
                  value={radio.toLowerCase()}
                >
                  {radio}
                </I2cRadioButton>
              ))}
            </I2cRadioGroup>
          </div>
          <div i2c-grid="12">
            <I2cRadioGroup
              label="Will the mobile app be hosted by i2c Inc.?"
              onI2cChange={(e) => {
                if (e.target.value === "yes") {
                  methods.setValue("of_dw_service_enable_via", "");
                }
                methods.setValue("of_dw_i2c_mobile_app_host", e.target.value);
                methods.trigger();
                handleValueChanges();
              }}
            >
              {inAppProvision.map((radio, index) => (
                <I2cRadioButton
                  key={index}
                  checked={
                    methods.watch("of_dw_i2c_mobile_app_host") ===
                    radio.toLowerCase()
                  }
                  value={radio.toLowerCase()}
                >
                  {radio}
                </I2cRadioButton>
              ))}
            </I2cRadioGroup>
          </div>

          {methods.watch("of_dw_i2c_mobile_app_host") === "no" && (
            <div i2c-grid="12">
              <I2cRadioGroup
                label="If you are not taking i2c hosted mobile app, would you like to
                  enable this service via:"
                onI2cChange={(e) => {
                  methods.setValue("of_dw_service_enable_via", e.target.value);
                  methods.trigger();
                  handleValueChanges();
                }}
              >
                <div i2c-grid="grid gap-sm">
                  {enableServices.map((radio, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="6@md"
                      variant="receipt"
                      label={radio}
                      sublabel=""
                      value=""
                      type="checkbox"
                      checked={
                        methods.watch("of_dw_service_enable_via") === radio
                      }
                    >
                      <I2cRadio
                        checked={
                          methods.watch("of_dw_service_enable_via") === radio
                        }
                        slot="prefix"
                        filled
                        name="ofdw_enableServices"
                        value={radio}
                      ></I2cRadio>
                    </I2cListItem>
                  ))}
                </div>
              </I2cRadioGroup>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default DigitalWallet;
